import React from 'react';
import styled from 'styled-components';

import theme from '../../../assets/theme';
import useResponses from '../../../hooks/useResponses';
import useVotes from '../../../hooks/useVotes';
import { RoundState, toIcon } from '../../../utils/roundUtils';
import { zIndexes } from '../../../utils/zIndexes';
import { IconWrapper } from '../../_atoms/IconWrapper';
import { Slide } from '../../SlideComponents/slide.types';

const ResponsecounterWidgetContainer = styled.div`
  display: flex;
  margin-bottom: 10px;
  color: ${theme.colors.white};
  width: max-content;
  font-size: 20px;
  cursor: pointer;
  padding: 10px;
  svg {
    cursor: pointer;
    color: ${theme.colors.white};
  }
  justify-content: space-evenly;
  align-items: center;
  background-color: ${theme.colors.translucentLightBlack};
  border-radius: 5px;
  z-index: ${zIndexes('LIVEGAME_TIMER_WIDGET')};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  &:hover {
    background-color: #656570;
  }
`;

const CounterViewer = ({
  currentSlide,
  count,
}: {
  currentSlide: Slide;
  roundState: RoundState;
  count: number;
}) => {
  return (
    <ResponsecounterWidgetContainer>
      <IconWrapper
        height={`30px`}
        width={`30px`}
        style={{ cursor: 'default', marginRight: '5px' }}
      >
        {toIcon(currentSlide.type as string).icon}
      </IconWrapper>

      <span>
        {' '}
        <strong> {count} </strong>
      </span>
    </ResponsecounterWidgetContainer>
  );
};

const VoteCounter = ({
  currentSlide,
  gameId,
  roundState,
  tenantId,
}: {
  gameId: string;
  tenantId: string;
  currentSlide: Slide;
  roundState: RoundState;
}) => {
  const { count } = useVotes(gameId, currentSlide.id, tenantId);
  return (
    <CounterViewer count={count} currentSlide={currentSlide} roundState={roundState} />
  );
};

const ResponseCounter = ({
  currentSlide,
  gameId,
  roundState,

  tenantId,
}: {
  gameId: string;
  tenantId: string;
  currentSlide: Slide;
  roundState: RoundState;
}) => {
  const { count } = useResponses(gameId, currentSlide.id, true, tenantId);
  return (
    <CounterViewer count={count} currentSlide={currentSlide} roundState={roundState} />
  );
};

const OmniCounter = ({
  currentSlide,
  gameId,
  roundState,

  tenantId,
}: {
  gameId: string;
  tenantId: string;
  currentSlide: Slide;
  roundState: RoundState;
}) => {
  if (currentSlide.type !== 'voting' && roundState === 'in') {
    return (
      <ResponseCounter
        currentSlide={currentSlide}
        roundState={roundState}
        gameId={gameId}
        tenantId={tenantId}
      />
    );
  }
  if (currentSlide.type === 'voting' && roundState === 'in') {
    return (
      <VoteCounter
        currentSlide={currentSlide}
        roundState={roundState}
        gameId={gameId}
        tenantId={tenantId}
      />
    );
  }

  return null;
};

export default React.memo(OmniCounter);
